import { KeyValue } from '@angular/common';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export class HttpClientWrapper {
  private headers: HttpHeaders = new HttpHeaders();
  private queryParams: HttpParams;
  private pathParams: KeyValue<any, any>[];
  private urlPath?: string;
  private requestBodyObj: any;
  private responseType = 'json';
  constructor(
    private baseUrl: string,
    private http: HttpClient
  ) {
    this.queryParams = new HttpParams();
    this.pathParams = [];
  }

  url(url: string) {
    this.urlPath = url;
    return this;
  }
  header(key: string, value: string) {
    this.headers = this.headers.set(key, value);
    return this;
  }
  queryParam(key: string, value: string | number | boolean) {
    this.queryParams = this.queryParams.append(key, value);

    return this;
  }
  pathParam(key: string, value: string) {
    this.pathParams.push({
      key,
      value: encodeURIComponent(value)
    });
    return this;
  }
  get<T>(): Observable<T> {
    const url = this.buildUrl();
    return this.http.get<T>(url, {
      params: this.queryParams,
      headers: this.headers,
      responseType: this.responseType as 'json'
    });
  }
  requestBody(requestBodyObj: any) {
    this.requestBodyObj = requestBodyObj;
    return this;
  }
  post<T>(): Observable<T> {
    const url = this.buildUrl();
    return this.http.post<T>(url, this.requestBodyObj, {
      headers: this.headers,
      responseType: this.responseType as 'json'
    });
  }
  put<T>(): Observable<T> {
    const url = this.buildUrl();
    return this.http.put<T>(url, this.requestBodyObj, {
      headers: this.headers,
      params: this.queryParams,
      responseType: this.responseType as 'json'
    });
  }
  setResponseType(responseType: string) {
    this.responseType = responseType;
    return this;
  }
  private buildUrl() {
    let url = this.baseUrl + this.urlPath;
    for (const item of this.pathParams) {
      url = url.replace(`{${item.key}}`, item.value);
    }
    return url;
  }

  delete<T>(): Observable<T> {
    const url = this.buildUrl();
    return this.http.delete<T>(url, {
      headers: this.headers,
      params: this.queryParams,
      responseType: this.responseType as 'json'
    });
  }

  patch<T>(): Observable<T> {
    const url = this.buildUrl();
    return this.http.patch<T>(url, this.requestBodyObj, {
      headers: this.headers,
      params: this.queryParams,
      responseType: this.responseType as 'json'
    });
  }
}
